import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAddPermission, checkEditPermission, checkDeletePermission, handleImportClickFile, handleExportFile, TableFooter, handleExportFileArrival, filteredCategories, relatedProductsLoadOptions, handleSelectionChange, fetchCategoryData, fetchOriginData, fetchPicSalesData, fetchPicImportData, fetchSuppliers, fetchShippingData, fetchCategoryDataFilter, fetchOriginDataFilter, fetchPicImportDataFilter, fetchPicSalesDataFilter, dateFormat, getCanonicalTimezone } from '../../../Utils/helper';
import { getApi, postApi, putApi, deleteApi } from '../../../Services/apiService';
import { toast } from 'react-toastify';
import Import from '../../../Utils/import';
import AddEditArrival from './addEditArrival';
import Modal from 'react-modal'
import { AsyncPaginate } from 'react-select-async-paginate';
import { components } from 'react-select';
import MultiSelectDropdown from '../../../Utils/multiSelectDropdown';
import { DatePicker } from 'antd';

import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

function Arrival() {

  const dropdownRef = useRef(null);
  const [methodType, setMethodType] = useState('');
  const { data } = useSelector((state) => state.roleData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [arrivals, setArrivals] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [arrivalToDelete, setArrivalToDelete] = useState(null);
  const [arrivalToEdit, setArrivalToEdit] = useState(null);

  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [showImportModalContainer, setShowImportModalContainer] = useState(false);
  const [importFileContainer, setImportFileContainer] = useState(null);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [productSearchQuery, setProductSearchQuery] = useState('');
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedShowProducts, setSelectedShowProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [supplierSearch, setSupplierSearch] = useState('');
  const [shippingMethods, setShippingMethods] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productlist, setProductList] = useState([])
  const [productShow, setProductShow] = useState([])
  const [expandedRow, setExpandedRow] = useState(null);
  const [categoryData, setCategoryData] = useState([])
  const [originData, setOriginData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [selectedPicImport, setSelectedPicImport] = useState([])
  const [selectedPicSales, setSelectedPicSales] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [selectedStatus, setSelectedStatus] = useState([])
  const [originOpen, setOriginOpen] = useState(false)
  const [picImporttOpen, setPicImporttOpen] = useState(false)
  const [picSalesOpen, setPicSalesOpen] = useState(false)
  const [statusOpen, setStatusOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [pageCount, setPageCount] = useState(null)
  const [picSalesData, setPicSalesData] = useState([])
  const [picImportData, setPicImportData] = useState([])
  const [viewHistoryModal, setViewHistoryModal] = useState(false)
  const [arrivalViewHistoryData, setArrivalViewHistoryData] = useState([])
  const [arrivalViewHistoryDataV2, setArrivalViewHistoryDataV2] = useState({})

  const [filterDatas, setFilterData] = useState([])
  const [etaOrderValue, setEtaOrderValue] = useState('asc')
const [dateState, setDateState] = useState({
  startDate: dayjs().format('YYYY-MM-DD'),
  endDate: dayjs().endOf('month').format('YYYY-MM-DD')
});
// console.log('originData', originData)
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });

  const [formData, setFormData] = useState({
    supplier: '',
    shipping_method: '',
    order_remark: '',
    container_no: '',
    atd: '',
    ata: '',
    eta: '',
    status: 0,
    arrival_id: ''
  });


  const [errors, setErrors] = useState({
    supplier: '',
    shipping_method: '',
    order_remark: '',
    container_no: '',
    atd: '',
    ata: '',
    eta: '',
    status: ''
  });

  const [touched, setTouched] = useState({
    supplier: false,
    shipping_method: false,
    order_remark: false,
    container_no: false,
    atd: false,
    ata: false,
    eta: false,
    status: false
  });

  const [products, setProducts] = useState([
    // {
    //   id: 1,
    //   product_code: '154215',
    //   product_name: 'NZ AMBROSIA APPLE',
    //   specification: '900 G / 12 PACK',
    //   quantity: '',
    //   barcode: '',
    //   checked: false
    // }
  ]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setPicSalesOpen(false);
        setPicImporttOpen(false)
        setCategoryOpen(false)
        setOriginOpen(false)
        setStatusOpen(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredProducts([]);
      setIsDropdownOpen(false);
      return;
    }
    const filtered = productlist.filter(product => {
      if (!product?.name_en) return false;
      const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
      const productWords = product.name_en.toLowerCase().split(/\s+/);
      return searchWords.every(searchWord =>
        productWords.some(productWord =>
          productWord.includes(searchWord)
        )
      );
    });
    setFilteredProducts(filtered);
    setIsDropdownOpen(filtered.length > 0);
  }, [searchTerm]);
const canonicalTimezone = getCanonicalTimezone();
const fetchArrivals = async () => {
  try {
    setIsLoading(true);
    setError(null);
    
    const queryParams = new URLSearchParams();

    // Category filter
    if (Array.isArray(selectedCategoryIds)) {
      selectedCategoryIds.forEach(id => queryParams.append('category_ids[]', id));
    } else if (selectedCategoryIds) {
      queryParams.append('category_ids[]', selectedCategoryIds);
    }

    // Status filter
    if (Array.isArray(selectedStatus)) {
      selectedStatus.forEach(id => queryParams.append('status', id));
    } else if (selectedStatus) {
      queryParams.append('status', selectedStatus);
    }

    // Origin filter
    if (Array.isArray(selectedOriginIds)) {
      selectedOriginIds.forEach(id => queryParams.append('origin_ids[]', id));
    } else if (selectedOriginIds) {
      queryParams.append('origin_ids[]', selectedOriginIds);
    }

    // PIC Import filter
    if (Array.isArray(selectedPicImport)) {
      selectedPicImport.forEach(id => queryParams.append('pic_staff_member_import[]', id));
    } else if (selectedPicImport) {
      queryParams.append('pic_staff_member_import[]', selectedPicImport);
    }

    // PIC Sales filter
    if (Array.isArray(selectedPicSales)) {
      selectedPicSales.forEach(id => queryParams.append('pic_staff_member_sales[]', id));
    } else if (selectedPicSales) {
      queryParams.append('pic_staff_member_sales[]', selectedPicSales);
    }

    // Date range filter (only if both dates are present)
    if (dateState.startDate && dateState.endDate) {
      queryParams.append('from_date', dateState.startDate);
      queryParams.append('to_date', dateState.endDate);
    }

    // Timezone handling with proper canonical names
    
    queryParams.append('timezone', canonicalTimezone);

    // Search and pagination
    queryParams.append('search', searchQuery);
    queryParams.append('page', currentPage);
    queryParams.append('per_page', itemsPerPage);
    
    // Sorting
    queryParams.append('sort_order', etaOrderValue);
    queryParams.append('sort_column', 'eta');

    const response = await getApi(`/arrival-summary?${queryParams.toString()}`);

    if (response?.success) {
      setArrivals(response.data.arrivalSummaries?.data || []);
      setPageCount(response.data.arrivalSummaries?.last_page || 1);
    } else {
      setError(response?.msg || 'Failed to fetch arrivals');
      setArrivals([]);
      setPageCount(1);
    }
  } catch (error) {
    setError(error.message || 'Failed to fetch arrivals');
    setArrivals([]);
    setPageCount(1);
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
    if (searchTerm !== '') {
      filterData()
    }
  }, [searchTerm])

  const filterData = () => {
    if (categoryOpen) {
      const data = filteredCategories(searchTerm, categoryData);
      setFilterData(data?.length > 0 ? data : []);
    } else if (originOpen) {
      const data = filteredCategories(searchTerm, originData);
      setFilterData(data?.length > 0 ? data : []);
    } else if (picImporttOpen) {
      const data = filteredCategories(searchTerm, picImportData);
      setFilterData(data?.length > 0 ? data : []);
    } else if (picSalesOpen) {
      const data = filteredCategories(searchTerm, picSalesData);
      setFilterData(data?.length > 0 ? data : []);
    }
  }

useEffect(() => {
  const timer = setTimeout(() => {
    fetchArrivals();
  }, 500); // Debounce for 500ms

  return () => clearTimeout(timer);
}, [
  searchQuery,
  selectedCategoryIds,
  selectedStatus,
  selectedOriginIds,
  selectedPicImport,
  selectedPicSales,
  dateState, // Reacts to date changes
  currentPage,
  itemsPerPage,
  etaOrderValue
]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (touched[name]) {
      validateField(name, value);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateField = (fieldName, value) => {
    let error = '';

    // Required fields validation
    if (['supplier', 'shipping_method', 'order_remark'].includes(fieldName)) {
      if (!value || (typeof value === 'string' && !value.trim())) {
        error = `${fieldName.replace('_', ' ')} is required`;
      }
    }

    // Date validation - ensure dates are in correct format
    if (['atd', 'ata', 'eta'].includes(fieldName)) {
      if (!value) {
        error = `${fieldName.toUpperCase()} is required`;
      } else if (isNaN(new Date(value).getTime())) {
        error = `Invalid ${fieldName.toUpperCase()} date format`;
      }
    }

    // Status validation
    if (fieldName === 'status') {
      if (value !== 0 && value !== 1) {
        error = 'Status must be selected';
      }
    }

    setErrors(prev => ({
      ...prev,
      [fieldName]: error
    }));

    return !error;
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name == 'eta' || name == 'atd' || name == 'ata') {
      if (value) {
        const [year, month, day] = value.split('-');
        const formattedDate = `${day}/${month}/${year}`;

        const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;

        if (!dateRegex.test(formattedDate)) {
          setTouched(prev => ({
            ...prev,
            [name]: true
          }));
          validateField(name, formattedDate);
        } else {
          setTouched(prev => ({
            ...prev,
            [name]: true
          }));
          validateField(name, value);
        }
      }
    } else {
      setTouched(prev => ({
        ...prev,
        [name]: true
      }));
      validateField(name, value);
    };
  }

  const validateForm = () => {
    let isValid = true;

    setTouched({
      supplier: true,
      shipping_method: true,
      order_remark: true,
      container_no: true,
      // atd: true,
      eta: true,
      status: true
    });


    ['supplier', 'shipping_method', 'container_no', 'eta','order_remark'].forEach(key => {
      const valid = validateField(key, formData[key]);
      if (!valid) isValid = false;
    });
    const hasCheckedProducts = productlist.some(product => product.checked === true);
    if (selectedShowProducts?.length == 0) {
      toast.error('Please add at least one product');
      return false;
    }
    if (selectedShowProducts?.length > 0) {
      // const invalidProducts = selectedShowProducts.filter(
      //   product => !product.quantity || product.quantity <= 0
      // );

      const invalidProducts = selectedShowProducts.filter(product => {
        return (
          product.quantity === undefined ||
          product.quantity === null ||
          isNaN(product.quantity)
        );
      });
      if (invalidProducts.length > 0) {
        toast.error('Please fill quantity for all selected products');
        return false;
      }
    }
    return isValid;
  };

  const resetForm = () => {
    setFormData({
      supplier: '',
      shipping_method: '',
      order_remark: '',
      container_no: '',
      atd: '',
      ata: '',
      eta: '',
      status: 0,
      arrival_id: formData?.arrival_id
    });

    setErrors({
      supplier: '',
      shipping_method: '',
      container_no: '',
      order_remark: '',
      atd: '',
      ata: '',
      eta: ''
    });
    setTouched({
      supplier: false,
      shipping_method: false,
      container_no: false,
      order_remark: false,
      atd: false,
      ata: false,
      eta: false
    });
    setProducts([]);
    setSelectedShowProducts([]);
    setProductList([]);
  };

  const resetFormArrival = async (types) => {
    types === 'add' ?
      setFormData({
        supplier: '',
        shipping_method: '',
        order_remark: '',
        container_no: '',
        atd: '',
        ata: '',
        eta: '',
        status: 0,
        arrival_id: formData?.arrival_id
      })
      :
      setFormData({
        supplier: arrivalToEdit.supplier_id || '',
        shipping_method: arrivalToEdit.shipping_method_name || '',
        order_remark: arrivalToEdit.order_remark || '',
        container_no: arrivalToEdit.container_no || '',
        atd: arrivalToEdit.atd || '',
        ata: arrivalToEdit.ata || '',
        eta: arrivalToEdit.eta || '',
        status: arrivalToEdit.status === true ? 1 : 0 || 0,
        arrival_id: arrivalToEdit?.arrival_id || ''
      });

    if (types === 'edit') {
      await getSingleArrivalProduct(arrivalToEdit);
    } else {
      setSelectedShowProducts([]);
      setProductList([]);
    }
    
    setErrors({
      supplier: '',
      shipping_method: '',
      container_no: '',
      order_remark: '',
      atd: '',
      ata: '',
      eta: ''
    });
    setTouched({
      supplier: false,
      shipping_method: false,
      container_no: false,
      order_remark: false,
      atd: false,
      ata: false,
      eta: false
    });
  }

  // Helper function to ensure no null/undefined values are sent
  const safeValue = (val) => (val === null || val === undefined ? '' : val);

  // --- handleAddArrival ---
  const handleAddArrival = async () => {
    const isValid = validateForm();
    if (!isValid) {
      return;
    }
    try {
      setIsLoading(true);
      const formDataPayload = new FormData();
      formDataPayload.append('supplier_id', safeValue(formData.supplier));
      formDataPayload.append('shipping_method_id', safeValue(formData.shipping_method));
      formDataPayload.append('order_remark', safeValue(formData.order_remark));
      formDataPayload.append('container_no', safeValue(formData.container_no));
      formDataPayload.append('atd', safeValue(formData.atd));
      formDataPayload.append('ata', safeValue(formData.ata));
      formDataPayload.append('eta', safeValue(formData.eta));
      formDataPayload.append('status', safeValue(formData.status));
      formDataPayload.append('arrival_id', safeValue(formData?.arrival_id));
      selectedShowProducts.forEach((product, index) => {
        formDataPayload.append(`products[${index}][id]`, safeValue(product?.id));
        formDataPayload.append(
          `products[${index}][quantity]`,
          product.quantity === '' || product.quantity === undefined || product.quantity === null
            ? 0
            : Number(product.quantity)
        );
        formDataPayload.append(`products[${index}][barcode]`, safeValue(product?.barcode) || 0);
      });

      const response = await postApi('/arrival-summary', formDataPayload);
      if (response?.success) {
        toast.success(response.msg || 'Arrival added successfully');
        await fetchArrivals();
        setMethodType('');
        resetForm();
        setSelectedProducts([]);
      } else {
        toast.error(response?.msg || 'Failed to add arrival');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || 'Failed to add arrival';
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateArrival = async () => {
    const isValid = validateForm();
    if (!isValid || !arrivalToEdit) {
      return;
    }

    try {
      setIsLoading(true);
      const formDataPayload = new URLSearchParams();
      formDataPayload.append('supplier_id', safeValue(formData.supplier));
      formDataPayload.append('shipping_method_id', safeValue(formData.shipping_method));
      formDataPayload.append('order_remark', safeValue(formData.order_remark));
      formDataPayload.append('container_no', safeValue(formData.container_no));
      formDataPayload.append('atd', safeValue(formData.atd));
      formDataPayload.append('ata', safeValue(formData.ata));
      formDataPayload.append('eta', safeValue(formData.eta));
      formDataPayload.append('status', safeValue(formData.status));
      formDataPayload.append('arrival_id', safeValue(formData?.arrival_id));
      selectedShowProducts.forEach((product, index) => {
        formDataPayload.append(`products[${index}][id]`, safeValue(product.id));
        formDataPayload.append(
          `products[${index}][quantity]`,
          product.quantity === '' || product.quantity === undefined || product.quantity === null
            ? 0
            : Number(product.quantity)
        );
        formDataPayload.append(`products[${index}][barcode]`, safeValue(product.barcode) || 0);
      });
      const response = await putApi(`/arrival-summary/${arrivalToEdit.id}`, formDataPayload.toString());
      if (response?.success) {
        toast.success(response.msg || 'Arrival updated successfully');
        await fetchArrivals();
        setMethodType('');
        resetForm();
        setSelectedProducts([]);
      } else {
        toast.error(response?.msg || 'Failed to update arrival');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || 'Failed to update arrival';
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const setupEditForm = async (arrival) => {
    setFormData({
      supplier: arrival.supplier_id,
      shipping_method: arrival.shipping_method_name,
      order_remark: arrival.order_remark,
      container_no: arrival.container_no,
      atd: arrival.atd,
      ata: arrival.ata,
      eta: arrival.eta,
      status: arrival.status,
      arrival_id: arrival?.arrival_id,
    });
    await getSingleArrivalProduct(arrival)
    setMethodType('edit');
    setArrivalToEdit(arrival);
  };

  const setupCloneForm = async (arrival) => {
    setFormData({
      supplier: arrival.supplier_id,
      shipping_method: arrival.shipping_method_name,
      order_remark: '',//arrival.order_remark,
      container_no: '',//arrival.container_no,
      atd: '',//arrival.atd,
      ata: '',//arrival.ata,
      eta: '',// arrival.eta,
      status: arrival.status === true ? 1 : 0,
      // arrival_id:''
    });

    const queryParams = new URLSearchParams();
    queryParams.append('page', 1);
    queryParams.append('per_page', 1);
    queryParams.append('sort_order', 'desc');
    queryParams.append('sort_column', 'arrival_id');
    // if (dateState.startDate && dateState.endDate) {
    //   queryParams.append('from_date', dateState.startDate);
    //   queryParams.append('to_date', dateState.endDate);
    // }
    queryParams.append('timezone', canonicalTimezone);
    const response = await getApi(`/arrival-summary?${queryParams.toString()}`);
    if (response?.success) {
      const sortedArrivals = [...response.data.arrivalSummaries?.data].sort((a, b) =>
        Number(b.arrival_id) - Number(a.arrival_id));
      const highestArrivalId = sortedArrivals[0]?.arrival_id
        ? Number(sortedArrivals[0].arrival_id)
        : 0;
      setFormData(prev => ({
        ...prev,
        'arrival_id': highestArrivalId + 1
      }));
    }
    await getSingleArrivalProduct(arrival, 'clone')
    setMethodType('clone');
    setArrivalToEdit(arrival);
  };

  const confirmDeleteArrival = async () => {
    if (!arrivalToDelete) return;

    try {
      setIsLoading(true);
      const response = await deleteApi(`/arrival-summary/${arrivalToDelete.id}`);

      if (response?.success) {
        toast.success(response.msg || 'Arrival deleted successfully');
        await fetchArrivals();
      } else {
        toast.error(response?.msg || 'Failed to delete arrival');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || 'Failed to delete arrival';
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
      setShowDeleteModal(false);
      setArrivalToDelete(null);
    }
  };

  const handleProductChange = (id, field, value) => {
    setSelectedShowProducts(prev => prev.map(product =>
      product.id === id ? { ...product, [field]: value } : product
    ));
    setProductList(prev => prev.map(product =>
      product.id === id ? { ...product, [field]: value } : product
    ));
  };

  const removeProducts = (idToRemove) => {
    // setProducts(prev => prev.filter(product => product.id !== id));
    setSelectedShowProducts(prevItems => prevItems.filter(item => item.id !== idToRemove));
  };

  const toggleProductCheckbox = (id, checked) => {
    setProducts(prev => prev.map(product =>
      product.id === id ? { ...product, checked } : product
    ));
  };

  const toggleAllProductsCheckbox = (isChecked) => {
    // setSelectedProducts(isChecked
    setSelectedShowProducts(isChecked
      ? productlist.map(product => ({
        ...product,
        // quantity: null,
        // barCode: null,
        checked: true
      }))
      : []);
    setProductList(isChecked
      ? productlist.map(product => ({
        ...product,
        // quantity: null,
        // barCode: null,
        checked: true
      }))
      : productlist.map(product => ({
        ...product,
        // quantity: null,
        // barCode: null,
        checked: false
      })));
  };

  const getSingleArrivalProduct = async (arrival, types) => {
    const resp = await getApi(`/arrival-summary/${arrival?.id}`)
    if (resp?.success) {
      setProductShow(resp?.data?.arrivalSummary?.products)
      if (types === 'clone') {
        setSelectedShowProducts(
          resp?.data?.arrivalSummary?.products?.map(product => ({
            ...product,
            checked: true,
            quantity: '',
            barcode: ''
          })) || []
        );
      } else {
        setSelectedShowProducts(
          resp?.data?.arrivalSummary?.products?.map(product => ({
            ...product,
            checked: true,
          })) || []
        );
      }
      setFormData(prev => ({
        ...prev,
        'shipping_method': resp?.data?.arrivalSummary?.shipping_method_id
      }));
    }
  }
  const viewArrivalDetails = async (arrival, type) => {
    await getSingleArrivalProduct(arrival)
    console.log(arrival, "arrival0datta")
    if (type !== 'show') {
      setMethodType('view');
      setArrivalToEdit(arrival);
    }
    if (type === 'show') {
      setExpandedRow(expandedRow === arrival?.id ? null : arrival?.id);
    }
    if (arrival.products && arrival.products.length > 0) {
      setProducts(arrival.products);
    }
  };
  const viewArrivalDetailHistory = async (arrival, type, nextarrival) => {
    // await getSingleArrivalProduct(arrival)
    if (type !== 'show') {
      setMethodType('view');
      setArrivalToEdit(arrival);
    }
    if (type === 'show') {
      setExpandedRow(expandedRow === arrival[0]?.id ? null : arrival[0]?.id);
    }
    if (arrival[0].products && arrival[0].products.length > 0) {
      setProducts(nextarrival[0].products);
    }
  };

  const fetchAvailableProducts = async () => {
    try {
      const response = await getApi(`/product?search=${encodeURIComponent(productSearchQuery)}&per_page=50`);
      if (response?.success) {
        setAvailableProducts(response.data.products.data || []);
      } else {
        toast.error(response?.msg || 'Failed to fetch products');
      }
    } catch (error) {
      toast.error(error.message || 'Failed to fetch products');
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (showAddProductModal) {
        fetchAvailableProducts();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [productSearchQuery, showAddProductModal]);

  useEffect(() => {
    fetchSuppliers('', setSuppliers);
    fetchShippingData('', setShippingMethods);
    // getProdcutData()
    fetchCategoryData('', setCategoryData)
    fetchOriginData('', setOriginData)
    fetchPicImportData('', setPicImportData)
    fetchPicSalesData('', setPicSalesData)
  }, []);


  const handleProductClick = (product) => {
    setSelectedProducts(prev => {
      const isAlreadySelected = prev.some(p => p.id === product.id);
      if (isAlreadySelected) {
        return prev.filter(p => p.id !== product.id);
      } else {
        return [...prev, {
          ...product,
          quantity: null,
          barCode: null,
        }];
        // return [...prev, product];
      }
    });
    setSearchTerm('');
    setIsDropdownOpen(false);
  };

  const createToggleHandler = (data, findFn, setState) => (selectedName) => {
    const selectedItem = data.find(item => findFn(item, selectedName));

    if (selectedItem) {
      setState(prevIds => {
        const identifier = selectedItem.id ?? selectedItem; // Handle both objects and primitives
        return prevIds.includes(identifier)
          ? prevIds.filter(id => id !== identifier)
          : [...prevIds, identifier];
      });
    }
  };

  const handleStatusToggle = (statusValue) => {
    setSelectedStatus(prev => {
      if (prev.length === 1 && prev[0] === statusValue) {
        return [];
      }
      return [statusValue];
    });
  };

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };
function buildHistoryTimeline(historyByDateKey) {
  const timelineMap = {}; // Keyed by changed_at
  const previousChanges = {
    eta: null,
    ata: null,
    atd: null,
    quantity: null,
  };

  // Sort keys oldest -> newest
  const sortedDates = Object.keys(historyByDateKey).sort((a, b) => new Date(a) - new Date(b));

  for (const date of sortedDates) {
    const changes = historyByDateKey[date];
    
//keep previous date data
    for (const change of changes) {
      const timeKey = change.changed_at;

      // If already exists, get the snapshot to overwrite
      

 
     let snapshot = {
          changed_at: change.changed_at,
          changed_by: change.changed_by,
          eta: previousChanges.eta,
          ata: previousChanges.ata,
          atd: previousChanges.atd,
          total_quantity: previousChanges.total_quantity,
        };
      

      // Update current state
      if (['eta', 'ata', 'atd', 'total_quantity'].includes(change.column_name)) {
        previousChanges[change.column_name] = change.new_value;
        snapshot[change.column_name] = change.new_value;
      }

      // Overwrite or create
      timelineMap[timeKey] = snapshot;
    }
  }


  return timelineMap;
}

  const handleViewHistory = async (arrival) => {
    console.log(arrival, "arrival0datta")
    setArrivalToEdit(arrival)
    const resp = await getApi(`/arrival-summary/${arrival?.id}`)
    if (resp?.success) {
      const sortedHistory = Object.entries(resp?.data?.histories || {})
        .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA));
      
      const historyByDateKey = sortedHistory.reduce((result, [date, value]) => {
        result[date] = value; // Properly assign the key and value
        return result;
      }, {});

      setArrivalViewHistoryData(historyByDateKey)

      const arrivalHistory=buildHistoryTimeline(historyByDateKey);
      console.log('arrivalHistory', arrivalHistory)
      setArrivalViewHistoryDataV2(arrivalHistory);
    }
    setViewHistoryModal(true)
  }

  const queryParams = {
    sort_order: 'desc',
    from_date:dateState?.startDate,
    to_date:dateState?.endDate,
    timezone:canonicalTimezone
  }

  const handleAddFunction = async () => {

    const queryParams = new URLSearchParams();
    queryParams.append('page', 1);
    queryParams.append('per_page', 1);
    queryParams.append('sort_order', 'desc');
    queryParams.append('sort_column', 'arrival_id');
    // if (dateState.startDate && dateState.endDate) {
    //   queryParams.append('from_date', dateState.startDate);
    //   queryParams.append('to_date', dateState.endDate);
    // }
    queryParams.append('timezone', canonicalTimezone);
    const response = await getApi(`/arrival-summary?${queryParams.toString()}`);
    if (response?.success) {
      const sortedArrivals = [...response.data.arrivalSummaries?.data].sort((a, b) =>
        Number(b.arrival_id) - Number(a.arrival_id));
      const highestArrivalId = sortedArrivals[0]?.arrival_id
        ? Number(sortedArrivals[0].arrival_id)
        : 0;
      setFormData(prev => ({
        ...prev,
        'arrival_id': highestArrivalId + 1
      }));
    }
    setMethodType('add');
    setSelectedShowProducts([]);

  }

  const handleDateFilterChange = (dates, dateStrings) => {
    setDateState({
      startDate: dateStrings[0] || '',
      endDate: dateStrings[1] || ''
    });
  };


  const hasFieldChangedFromPrevious = (fieldName) => {
    const sortedHistoryEntries = Object.entries(arrivalViewHistoryData)
    .sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const latestHistoryChanges = sortedHistoryEntries?.[0]?.[1];

    if (!latestHistoryChanges) return false;
    const historyChange = latestHistoryChanges.find(change => change.column_name === fieldName);
    if (!historyChange) return false;

    const previousVal = historyChange?.old_value;
    const currentVal = arrivalToEdit?.[fieldName];

    const normalize = (val) => val === 'null' || val == null ? '' : val;

    return normalize(currentVal) !== normalize(previousVal);
  };




  return (
    <div className={`RightSideDiv ${methodType === 'add' || 'edit' ? 'arive add-arr' : ''}`}>

      {showAddProductModal && (
        <div className="modal-overlay arive-add-product">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Add Product</h3>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                onClick={() => { setShowAddProductModal(false); setSelectedProducts([]); setSearchTerm('') }}
                className="close"
                alt="Close"
              />
            </div>
            <div className="modal-body p-0">
              <div className="form-group">
                <label>Search Product</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by product code or name"
                  value={searchTerm}
                  onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1) }}
                  onFocus={() => searchTerm.trim() !== '' && setIsDropdownOpen(true)}
                />
              </div>
              <div className="product-list">

                <table className="custom-table table-striped product-bottom-cs">
                  <thead>
                    <tr>
                      <th className="checkbox">
                        <label className="checbox-cs">
                          <input
                            type="checkbox"
                            onChange={(e) => toggleAllProductsCheckbox(e.target.checked)}
                            checked={productlist.length > 0 && selectedProducts.length === productlist.length}
                            indeterminate={
                              selectedProducts.length > 0 &&
                              selectedProducts.length < productlist.length
                            }
                          />
                          <span className="checkmark"></span>
                        </label>
                      </th>
                      <th className="product-code">Product Code</th>
                      <th className="product-name">Product Name</th>
                      <th className="specification">Specification</th>
                      <th className="quantity">Quantity</th>
                      <th className="barcode">Barcode</th>
                      {/* <th className="action">Action</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {(filteredProducts && filteredProducts.length > 0 ? filteredProducts : productlist).map((product, index) => (
                      // index<10 &&
                      <tr key={product.id}>
                        <td className="checkbox">
                          <label className="checbox-cs">
                            <input
                              type="checkbox"
                              checked={selectedProducts.some(p => p.id === product.id)}
                              onClick={() => handleProductClick(product)}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                        <td className="product-code">{product.code}</td>
                        <td className="product-name">{product.name_en}</td>
                        <td className="specification">{product.specification}</td>
                        <td className="quantity">
                          <input
                            type="text"
                            className='input-enter'
                            placeholder="10"
                            value={product.quantity}
                            onChange={(e) => handleProductChange(product.id, 'quantity', e.target.value)}
                          />
                        </td>
                        <td className="barcode">
                          <input
                            type="text"
                            className='input-enter'
                            placeholder="10"
                            value={product.barcode}
                            onChange={(e) => handleProductChange(product.id, 'barcode', e.target.value)}
                          />
                        </td>
                        {/* <td className="action">
                          <div className="">
                            <button
                              className="cross-btn"
                              onClick={() => removeProduct(product.id)}
                            >
                              <img src={window.getPublicUrl('/assets/images/white-cross.png')} alt="" />
                            </button>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button className="reset" onClick={() => { setSelectedProducts([]); setShowAddProductModal(false); setSearchTerm('') }}>
                Cancel
              </button>
              <button
                className="save mt-0"
                onClick={() => {
                  if (selectedProducts.length === 0) {
                    toast.error('Please select at least one product');
                    return;
                  }
                  // setSelectedShowProducts(selectedProducts)
                  setSelectedProducts([]);
                  setShowAddProductModal(false);
                  setSearchTerm('')
                }}
                disabled={selectedProducts.length === 0}
              >
                Add Selected Products ({selectedProducts.length})
              </button>
            </div>
          </div>
        </div>
      )}

      {showImportModal && (
        <Import
          setImportFile={setImportFile}
          importFile={importFile}
          searchQuery={searchQuery}
          fetchData={fetchArrivals}
          setShowImportModal={setShowImportModal}
          routeEnd={'/arrival-summary/import'}
          routeexport={`/arrival-summary/export`}
          type={'ArrivalSummary'}
          queryParams={queryParams}
        />
      )}
      {showImportModalContainer && (
        <Import
          setImportFile={setImportFileContainer}
          importFile={importFileContainer}
          searchQuery={''}
          fetchData={fetchArrivals}
          setShowImportModal={setShowImportModalContainer}
          routeEnd={'/arrival-summary/container-import'}
          routeexport={`/arrival-summary/container-export`}
          type={'ArrivalSummary Container'}
          queryParams={''}
        />
      )}

      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Confirm Deletion</h3>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                onClick={() => setShowDeleteModal(false)}
                className="close"
                alt="Close"
              />
            </div>
            <div className="modal-body mb-0 p-0">
              <p>Are you sure you want to delete the arrival with arrival id: <strong>{arrivalToDelete?.arrival_id}</strong>?</p>
              <p>This action cannot be undone.</p>
            </div>
            <div className="modal-footer">
              <button className="reset" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </button>
              <button
                className="save mt-0"
                onClick={confirmDeleteArrival}
                disabled={isLoading}
              >
                {isLoading ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Arrivals List */}
      {methodType === '' && (
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right setting-right-table table-border-show arrival">
              <div className="table-header  border-bt">
                <div className="search-card only-arival">
                  <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search Container No/Air/Local/Truck order remark"
                    value={searchQuery}
                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                  />
                </div>
                <div className="table-actions">
                {checkAddPermission(data?.permissions, 'arrival') && (
                  <button
                    className="btn"
                    onClick={() => handleImportClickFile(setShowImportModal, setImportFile, setImportErrors)}
                  >
                    <img src={window.getPublicUrl('/assets/images/import-icon-black.svg')} alt="" />
                    Import Arrival
                  </button>
                )}
                  {checkAddPermission(data?.permissions, 'arrival') && (
                  <button className="btn" onClick={() => handleImportClickFile(setShowImportModalContainer, setImportFileContainer, setImportErrors)}>
                    <img src={window.getPublicUrl('/assets/images/update.svg')} alt="" />
                    Container Update
                  </button>
                  )}
                  <button
                    className="btn"
                    onClick={() => handleExportFileArrival( searchQuery, 'arrival_summary.xlsx', '/arrival-summary/export', selectedCategoryIds, selectedOriginIds, selectedStatus,dateState.startDate,dateState.endDate,canonicalTimezone,selectedPicImport,selectedPicSales,etaOrderValue)}
                  >
                    <img src={window.getPublicUrl('/assets/images/export.svg')} alt="" />
                    Export
                  </button>
                  {checkAddPermission(data?.permissions, 'arrival') && (
                    <button className="btn add" onClick={() => { handleAddFunction(); }}>
                      + Add Arrival
                    </button>
                  )}
                </div>
              </div>
              <div className="table-header table-second">
                <div className="links">
                    <MultiSelectDropdown
                      categoryData={categoryData}
                      selectedCategories={selectedCategoryIds}
                      setSelectedCategories={setSelectedCategoryIds}
                      placeholder='Select Categories...'
                      noOptionsMessage='No categories available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchCategoryDataFilter}
                    />
                 
                    <MultiSelectDropdown
                      categoryData={originData}
                      selectedCategories={selectedOriginIds}
                      setSelectedCategories={setSelectedOriginIds}
                      placeholder="Select origin..."
                      noOptionsMessage='No origin available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchOriginDataFilter}
                    />
                  <div className='selctions-option'>
                    <input placeholder="category" class={`category ${statusOpen ? 'before-change-cs' : ''} affter-change-cs category-select`} value="Status" onClick={() => setStatusOpen(!statusOpen)} />
                    {statusOpen &&
                      <div className='select-option' ref={dropdownRef}>
                        <span>
                          <label class="checbox-cs">
                            <input type="checkbox" onClick={(e) => { handleStatusToggle(1);setCurrentPage(1) }} checked={selectedStatus.includes(1) ? true : false} />
                            <span class="checkmark" ></span>
                          </label>
                          Completed
                        </span>
                        <span>
                          <label class="checbox-cs">
                            <input type="checkbox" onClick={(e) => { handleStatusToggle(0);setCurrentPage(1) }} checked={selectedStatus.includes(0) ? true : false} />
                            <span class="checkmark" ></span>
                          </label>
                          Incompleted
                        </span>
                      </div>
                    }
                  </div>
                    <MultiSelectDropdown
                      categoryData={picImportData}
                      selectedCategories={selectedPicImport}
                      setSelectedCategories={setSelectedPicImport}
                      placeholder="Select pic import ..."
                      noOptionsMessage='No pic import available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchPicImportDataFilter}
                    />
                    <MultiSelectDropdown
                      categoryData={picSalesData}
                      selectedCategories={selectedPicSales}
                      setSelectedCategories={setSelectedPicSales}
                      placeholder="Select pic sales..."
                      noOptionsMessage='No pic sales available'
                      setCurrentPage={setCurrentPage}
                      fetchOptionsApi={fetchPicSalesDataFilter}
                    />
                  <div className='selctions-option'>
                    <RangePicker
                      key={'pathName'}
                      onChange={handleDateFilterChange}
                      separator={'-'}
                      // placeholder={[t('FROM'), t('TO')]}
                      // disabledDate={(current) => current && current < dayjs().startOf('day')}
                      value={[
                        dateState.startDate ? dayjs(dateState.startDate) : null,
                        dateState.endDate ? dayjs(dateState.endDate) : null
                      ]}
                      allowClear={false}
                    />
                    </div>
                </div>
              </div>
              <div className="permission-table-inner arival-view-table">
                <table className="custom-table table-striped">
                  <thead>
                    <tr>
                      <th className="id">ID</th>
                      <th className="shipping-method">Shipping Method</th>
                      <th className="shipping-name">Supplier Name</th>
                      <th className="container-no">Container No/Air/Local/Truck</th>
                      <th className="order-remark">Order Remark</th>
                      <th className="atd">ATD</th>
                      <th className="ata">ATA</th>
                      <th className="eta">ETA <a className='sort-by' href="#">
                        <img src={window.getPublicUrl('/assets/images/up-arrow.svg')} className='ps-2 up-arrow' alt="" onClick={() => setEtaOrderValue('asc')} />
                        <img src={window.getPublicUrl('/assets/images/down-arrow.svg')} className='ps-2 down-arrow' alt="" onClick={() => setEtaOrderValue('desc')} /></a>

                      </th>
                      <th className="products">Products</th>
                      <th className="total-qty">Total Qty</th>
                      <th className="added-by">Added By</th>
                      <th className="status">Status</th>
                      <th className="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="12" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : arrivals.length === 0 ? (
                      <tr>
                        <td colSpan="12" className="text-center">No arrivals found</td>
                      </tr>
                    ) : (
                      arrivals.map((arrival, index) => (
                        <React.Fragment key={arrival.id}>
                          <tr key={arrival.id}>
                            <td className="id">{arrival?.arrival_id}</td>
                            {/* <td className="id">{index + 1}</td> */}
                            <td className="shipping-method">{arrival.shipping_method_name}</td>
                            <td className="shipping-name">{arrival.supplier_name_en}</td>
                            <td className="container-no">{arrival.container_no}</td>
                            <td className="order-remark">{arrival.order_remark}</td>
                            <td className="atd">{arrival.atd}</td>
                            <td className="ata">{arrival.ata}</td>
                            <td className="eta">{arrival.eta}</td>
                            <td className="products">
                              <a href="#" onClick={(e) => { e.preventDefault(); viewArrivalDetails(arrival, 'show'); }}>
                                {/* Show */}
                                {expandedRow === arrival.id ? 'Hide' : 'Show'}
                              </a>
                            </td>
                            <td className="total-qty">
                              {/* {arrival.products?.reduce((sum, product) => sum + (parseInt(product.quantity) || 0), 0)} */}
                              {arrival?.previous_total_quantity != null ? `${arrival?.previous_total_quantity} -> ${arrival?.total_quantity}` : arrival?.total_quantity}
                            </td>
                            <td className="added-by">{arrival.added_by}</td>
                            <td className="status">
                              <span className={`status-badge ${arrival.status ? 'active' : 'inactive'}`}>
                                {arrival.status ? 'Completed' : 'Incompleted'}
                              </span>
                            </td>
                            <td className="action action-cs">
                              <div className="dropdown">
                                <button
                                  className=" dropdown-toggle action-btn"
                                  type="button"
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <img src={window.getPublicUrl('/assets/images/dots-icon.svg')} alt="Actions" />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        viewArrivalDetails(arrival, 'view');
                                        setExpandedRow(null);
                                      }}
                                    >
                                      View
                                    </a>
                                  </li>

                                  {arrival?.histories_count > 1 && (
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleViewHistory(arrival);
                                          setExpandedRow(null);
                                        }}
                                      >
                                        View History
                                      </a>
                                    </li>
                                  )}

{checkAddPermission(data?.permissions, 'arrival') && (
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setupCloneForm(arrival);
                                        setExpandedRow(null);
                                      }}
                                    >
                                      Clone
                                    </a>
                                  </li>
)}

                                  {checkEditPermission(data?.permissions, 'arrival') && (
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setupEditForm(arrival);
                                          setExpandedRow(null);
                                        }}
                                      >
                                        Edit
                                      </a>
                                    </li>
                                  )}

                                  {checkDeletePermission(data?.permissions, 'arrival') && (
                                    <li>
                                      <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setArrivalToDelete(arrival);
                                          setShowDeleteModal(true);
                                          setExpandedRow(null);
                                        }}
                                      >
                                        Delete
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </td>
                          </tr>

                          {expandedRow === arrival.id && !viewHistoryModal && (
                            <tr className="sub-table-row">
                              <td colSpan="12" >
                                <div className="sub-table-outer">
                                  <table className="sub-table">
                                    <thead>
                                      <tr>
                                        <th className="product-code">Product Code</th>
                                        <th className="product-name">Product Name</th>
                                        <th className="specification">Specification</th>
                                        <th className="qty">Qty</th>
                                        <th className="barcode">Barcode</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {productShow?.map((product, idx) => (
                                        <tr key={idx}>
                                          <td className="product-code">{product.code}</td>
                                          <td className="product-name">{product.name_tc}</td>
                                          <td className="specification">{product.specification}</td>
                                          <td className="qty">{product.quantity}</td>
                                          <td className="barcode">{product.barcode || '-'}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>

                      ))
                    )}

                    <Modal
                      isOpen={viewHistoryModal}
                      onRequestClose={() => setViewHistoryModal(false)}
                      contentLabel="History Modal"
                      shouldCloseOnOverlayClick={true}
                      ariaHideApp={false}
                      overlayClassName="modal-overlay add-category delete logout view-history-details"
                      portalClassName="add-user delete inventory-history-cs"
                    >
                      <div className='modal-content'>
                        <div className='modal-header'>
                          <h3>History</h3>
                          <img
                            src={window.getPublicUrl('/assets/images/close.svg')}
                            onClick={() => { setViewHistoryModal(false); setExpandedRow(null) }}
                            className="close"
                            alt="Close"
                          />
                        </div>
                        <div className='onscroll-history'>
                          <div className='modal-body mb-0 p-0'>
                            <div className='permission-table-inner arrival main-head'>
                              <div className="mb-4 w-100 d-flex align-items-center ">
                                <h3>{(() => {
                                        const nextEntry = Object.entries(arrivalViewHistoryData);
                                        const lastEntry = nextEntry.at(0);
                                        const nextDate = lastEntry?.[0];
                                        if (nextDate) {
                                          return <h3>{dateFormat(nextDate)}</h3>;
                                        }
                                        return null;
                                      })()}</h3>
                                <table className='custom-table table-striped'>
                                  <thead>
                                    <tr>
                                      <th className="id">ID</th>
                                      <th className="shipping-method">Shipping Method</th>
                                      <th className="container-no">Container No/Air/Local/Truck</th>
                                      <th className="order-remark">Order Remark</th>
                                      <th className="atd">ATD</th>
                                      <th className="ata">ATA</th>
                                      <th className="eta">ETA</th>
                                      <th className="products">Products</th>
                                      <th className="total-qty">Total Qty</th>
                                      <th className="added-by">Added By</th>
                                      <th className="updated-at">Updated By</th>
                                      <th className="status">Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    <td className="id">{arrivalToEdit?.arrival_id}</td>
                                    <td className={`shipping-method `}>
                                      {arrivalToEdit?.shipping_method_name}
                                    </td>
                                    <td className={`container-no  `}>
                                      {(arrivalToEdit?.container_no === 'null' || arrivalToEdit?.container_no === null) ? '' : arrivalToEdit?.container_no}
                                    </td>
                                    <td className={`order-remark  `}>
                                      {(arrivalToEdit?.order_remark === 'null' || arrivalToEdit?.order_remark === null) ? '' : arrivalToEdit?.order_remark}
                                    </td>
                                    <td className={`atd ${hasFieldChangedFromPrevious("atd") ? "updated-fw" : ""}`}>
                                      {(arrivalToEdit?.atd === 'null' || arrivalToEdit?.atd === null) ? '' : arrivalToEdit?.atd}
                                    </td>
                                    <td className={`ata ${hasFieldChangedFromPrevious("ata") ? "updated-fw" : ""}`}>
                                      {(arrivalToEdit?.ata === 'null' || arrivalToEdit?.ata === null) ? '' : arrivalToEdit?.ata}
                                    </td>
                                    <td className={`eta ${hasFieldChangedFromPrevious("eta") ? "updated-fw" : ""}`}>
                                      {(arrivalToEdit?.eta === 'null' || arrivalToEdit?.eta === null) ? '' : arrivalToEdit?.eta}
                                    </td>
                                    <td className="products">
                                      <a href="#" onClick={(e) => { e.preventDefault(); viewArrivalDetails(arrivalToEdit, 'show'); }}>
                                        {expandedRow === arrivalToEdit?.id ? 'Hide' : 'Show'}
                                      </a>
                                    </td>
                                    <td className={`total-qty atd ${hasFieldChangedFromPrevious("total_quantity") ? "updated-fw" : ""}`}>
                                      {arrivalToEdit?.total_quantity}
                                    </td>
                                    <td className={`added-by `}>
                                      {arrivalToEdit?.added_by}
                                    </td>
                                    <td className="updated-at">
                                      {Object.entries(arrivalViewHistoryData)?.[0]?.[1]?.[0]?.changed_by}
                                    </td>
                                    <td className={`status  `}>
                                      <span className={`status-badge active`}>
                                        Active
                                      </span>
                                    </td>
                                  </tr>

                                    {expandedRow === arrivalToEdit?.id && (
                            <tr className="sub-table-row">
                              <td colSpan="12" className=' modal-sub-rowddata'>
                                <div className="sub-table-outer">
                                  <table className="sub-table">
                                    <thead>
                                      <tr>
                                        <th className="product-code">Product Code</th>
                                        <th className="product-name">Product Name</th>
                                        <th className="specification">Specification</th>
                                        <th className="qty">Qty</th>
                                        <th className="barcode">Barcode</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {productShow?.map((product, idx) => {
                                        const nextEntry = Object.entries(arrivalViewHistoryData);
                                        const lastEntry = nextEntry.at(1);
                                        const prevEntry = lastEntry?.[1]?.[0];
                                        let isChanged = false;
                                    
                                        if (prevEntry) {
                                          const prevProduct = prevEntry?.products
                                            .find(p => p.product_id === product.id);
                                          if (prevProduct && prevProduct.quantity !== product.quantity) {
                                            isChanged = true;
                                          }
                                        }
                                        return(
                                        <tr key={idx}>
                                          <td className="product-code">{product.code}</td>
                                          <td className="product-name">{product.name_en}</td>
                                          <td className="specification">{product.specification}</td>
                                          <td className={`qty ${isChanged ? 'atd updated-fw' : ''}`}>{product.quantity}</td>
                                          <td className="barcode">{product.barcode || '-'}</td>
                                        </tr>
                                        )
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          
                          {/* <div className='modal-footer text-start justify-content-start'>
                            {arrivalViewHistoryData && Object.entries(arrivalViewHistoryData).sort((a, b) => new Date(b[0]) - new Date(a[0])).map(([date, changes], index, allEntries) => {
                            // {arrivalViewHistoryData && Object.entries(arrivalViewHistoryData).sort((a, b) => new Date(b[0]) - new Date(a[0])).slice(0, 3).map(([date, changes], index, allEntries) => {
                              if (index > allEntries.length - 1) return null;
                              if (index != Object.entries(arrivalViewHistoryData)?.length - 1) {

                                const getOldOrCurrentValue = (fieldName, currentValue) => {
                                  const currentChange = changes.find(change => change.column_name === fieldName);
                                  if (index === 0) {
                                    if (!currentChange) {
                                      return currentValue;
                                    } else {
                                      return currentChange?.old_value //|| currentChange?.new_value
                                    }
                                  }
                                  if (currentChange?.new_value) {
                                    return currentChange?.old_value;
                                  }
                                  const prevEntry = Object.entries(arrivalViewHistoryData)[index - 1]?.[1];
                                  const previousChange = prevEntry.find(change => change.column_name === fieldName);
                                  if (previousChange) { return previousChange?.old_value }
                                  return currentValue;
                                };
                                const isFieldUpdated = (fieldName) => {
                                  return changes.some(change => change.column_name === fieldName);
                                };
                                if (index != Object.entries(arrivalViewHistoryData)?.length - 1) {
                                  return (
                                    <div key={index} className="mb-4 w-100 d-flex align-items-center arrival">
                                    
                                      <h3>{(() => {
                                        const nextEntry = Object.entries(allEntries)[index + 1];
                                        const nextDate = nextEntry?.[1]?.[0];
                                        if (nextDate) {
                                          return <h3>{dateFormat(nextDate)}</h3>;
                                        }
                                        return null;
                                      })()}</h3>
                                      <table className='custom-table table-striped'>
                                        <tbody>
                                          <tr>
                                            <td className={`shipping_method_name ${(isFieldUpdated("shipping_method_name")&& index< allEntries.length - 2)? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("shipping_method_name", arrivalToEdit?.shipping_method_name);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`container-no ${(isFieldUpdated("container-no")&& index< allEntries.length - 2) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("container_no", arrivalToEdit?.container_no);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`order-remark ${(isFieldUpdated("order-remark")&& index< allEntries.length - 2) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("order_remark", arrivalToEdit?.order_remark);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("atd")&& index< allEntries.length - 2) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("atd", arrivalToEdit?.atd);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("ata")&& index< allEntries.length - 2) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("ata", arrivalToEdit?.ata);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("eta") && index< allEntries.length - 2)? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("eta", arrivalToEdit?.eta);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className="products">
                                              <a href="#" onClick={(e) => { e.preventDefault(); const nextChanges = Object.entries(arrivalViewHistoryData)[index + 1]?.[1]; viewArrivalDetailHistory(changes, 'show', nextChanges); }}>
                                                {expandedRow === changes[0]?.id ? 'Hide' : 'Show'}
                                              </a>
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("total_quantity") && index < allEntries.length - 2) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("total_quantity", arrivalToEdit?.total_quantity);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className="name-tc">
                                              {(() => {
                                                const val = getOldOrCurrentValue("added_by", arrivalToEdit?.added_by);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className="name-tc updated-fw">{changes[0]?.changed_by}</td>
                                            <td className={`status ${(isFieldUpdated("status")&& index< allEntries.length - 2) ? 'updated-fw' : ''}`}>
                                              <span className={`status-badge inactive`}>
                                                InActive
                                              </span>
                                            </td>
                                          </tr>
                                          {expandedRow === changes[0]?.id && (
                                            <tr className="sub-table-row">
                                              <td colSpan="12" >
                                                <div className="sub-table-outer">
                                                  <table className="sub-table">
                                                    <thead>
                                                      <tr style={{ border: '0' }}>
                                                        <th className="product-code">Product Code</th>
                                                        <th className="product-name">Product Name</th>
                                                        <th className="specification">Specification</th>
                                                        <th className="qty">Qty</th>
                                                        <th className="barcode">Barcode</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {products?.map((product, idx) => {

                                                        const prevEntry = Object.entries(allEntries)[index + 2]?.[1]?.[1]; // next in sorted list is older
                                                  
                                                      let isChanged = false;
                                                  
                                                      if (prevEntry) {
                                                        const prevProduct = prevEntry
                                                          .flatMap(log => log.products || [])
                                                          .find(p => p.product_id === product.product_id);
                                                        if (prevProduct && prevProduct.quantity !== product.quantity) {
                                                          isChanged = true;
                                                        }
                                                      }

                                                        return (
                                                          <tr key={idx} style={{ border: '0' }}>
                                                            <td className="product-code">{product?.product_code || product?.product?.code}</td>
                                                            <td className="product-name">{product?.product_name || product?.product?.name_en}</td>
                                                            <td className="specification">{product?.specification || product?.product?.specification}</td>
                                                            <td className={`qty ${isChanged ? 'atd updated-fw' : ''}`}>{product.quantity || product?.product?.quantity}</td>
                                                            <td className="barcode">{product.barcode || product?.product?.barcode || '-'}</td>
                                                          </tr>
                                                        )
                                                      })}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  );
                                }
                              }
                            })}

                          </div> */}

                         <div className='modal-footer text-start justify-content-start'>
                            {arrivalViewHistoryData && Object.entries(arrivalViewHistoryData).sort((a, b) => new Date(b[0]) - new Date(a[0])).map(([date, changes], index, allEntries) => {
                              const sortedEntries = Object.entries(arrivalViewHistoryData).sort((a, b) => new Date(b[0]) - new Date(a[0]));
                              const lastIndex = sortedEntries.length - 1;

                                
                              const getOldOrCurrentValue = (fieldName, currentValue) => {
                                 return  arrivalViewHistoryDataV2[changes[0].changed_at]?.[fieldName];
                              };
                                const isFieldUpdated = (fieldName) => {
                                  return changes.some(change => change.column_name === fieldName);
                                };
                                if (index !== 0) {
                                  return (
                                    <div key={index} className="mb-4 w-100 d-flex align-items-center arrival">
                                      {/* <h3>{dateFormat(dates)}</h3> */}
                                      <h3>{(() => {
                                          return <h3>{dateFormat(Object.entries(allEntries)[index]?.[1]?.[0])} </h3>;
                                      })()}</h3>
                                      <table className='custom-table table-striped'>
                                        <tbody>
                                          <tr>
                                            <td className={`shipping_method_name  `}>
                                             {arrivalToEdit?.shipping_method_name}
                                            </td>
                                            <td className={`container-no `}>
                                             {arrivalToEdit?.container_no}
                                            </td>
                                            <td className={`order-remark `}>
                                              {arrivalToEdit?.order_remark}
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("atd") && index < lastIndex) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("atd", arrivalToEdit?.atd);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("ata") && index < lastIndex) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("ata", arrivalToEdit?.ata);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("eta") && index < lastIndex )? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("eta", arrivalToEdit?.eta);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className="products">
                                              <a href="#" onClick={(e) => { e.preventDefault(); const nextChanges = Object.entries(arrivalViewHistoryData)[index]?.[1]; viewArrivalDetailHistory(changes, 'show', nextChanges); }}>
                                                {expandedRow === changes[0]?.id ? 'Hide' : 'Show'}
                                              </a>
                                            </td>
                                            <td className={`atd ${(isFieldUpdated("total_quantity") && index < lastIndex  ) ? 'updated-fw' : ''}`}>
                                              {(() => {
                                                const val = getOldOrCurrentValue("total_quantity", arrivalToEdit?.total_quantity);
                                                return (val === 'null' || val === null) ? '' : val;
                                              })()}
                                            </td>
                                            <td className="name-tc">
                                              {arrivalToEdit?.added_by}
                                            </td>
                                            <td className="name-tc ">{changes[0]?.changed_by}</td>
                                            <td className={`status`}>
                                              <span className={`status-badge inactive`}>
                                                InActive
                                              </span>
                                            </td>
                                          </tr>
                                          {expandedRow === changes[0]?.id && (
                                            <tr className="sub-table-row">
                                              <td colSpan="12" >
                                                <div className="sub-table-outer">
                                                  <table className="sub-table">
                                                    <thead>
                                                      <tr style={{ border: '0' }}>
                                                        <th className="product-code">Product Code</th>
                                                        <th className="product-name">Product Name</th>
                                                        <th className="specification">Specification</th>
                                                        <th className="qty">Qty</th>
                                                        <th className="barcode">Barcode</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {products?.map((product, idx) => {

                                                        const prevEntry = Object.entries(allEntries)[index + 1]?.[1]?.[1]; // next in sorted list is older
                                                  
                                                      let isChanged = false;
                                                  
                                                      if (prevEntry) {
                                                        const prevProduct = prevEntry
                                                          .flatMap(log => log.products || [])
                                                          .find(p => p.product_id === product.product_id);
                                                        if (prevProduct && prevProduct.quantity !== product.quantity) {
                                                          isChanged = true;
                                                        }
                                                      }

                                                        return (
                                                          <tr key={idx} style={{ border: '0' }}>
                                                            <td className="product-code">{product?.product_code || product?.product?.code}</td>
                                                            <td className="product-name">{product?.product_name || product?.product?.name_en}</td>
                                                            <td className="specification">{product?.specification || product?.product?.specification}</td>
                                                            <td className={`qty ${isChanged ? 'atd updated-fw' : ''}`}>{product.quantity || product?.product?.quantity}</td>
                                                            <td className="barcode">{product.barcode || product?.product?.barcode || '-'}</td>
                                                          </tr>
                                                        )
                                                      })}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  );
                                }
                              
                            })}

                          </div>
                        </div>
                      </div>
                    </Modal>

                  </tbody>
                </table>

              </div>
              {arrivals?.length > 0 &&
                <div class="table-footer d-flex justify-content-between table-pagination">
                  <select name="" id="" className='affter-change-cs page' value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                  <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                  </select>
                  <div className=''>
                    <TableFooter
                      pageCount={pageCount}
                      handlePageClick={handlePageClick}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      )}

      {/* Add Arrival Form */}
      {methodType === 'add' && (
        <AddEditArrival setMethodType={setMethodType} resetForm={resetForm} touched={touched} errors={errors} formData={formData} handleInputChange={handleInputChange} handleBlur={handleBlur} suppliers={suppliers} shippingMethods={shippingMethods} handleDateChange={handleDateChange} searchTerm={searchTerm} setIsDropdownOpen={setIsDropdownOpen} isDropdownOpen={isDropdownOpen} filteredProducts={filteredProducts} selectedProducts={selectedProducts} setSearchTerm={setSearchTerm} handleProductClick={handleProductClick} setShowAddProductModal={setShowAddProductModal} setProductSearchQuery={setProductSearchQuery} setAvailableProducts={setAvailableProducts} setSelectedProducts={setSelectedProducts} fetchAvailableProducts={fetchAvailableProducts} toggleAllProductsCheckbox={toggleAllProductsCheckbox} products={products} toggleProductCheckbox={toggleProductCheckbox} handleProductChange={handleProductChange} removeProduct={removeProducts} handleAddArrival={handleAddArrival} isLoading={isLoading} type={'add'} arrivalToEdit={arrivalToEdit} selectedShowProducts={selectedShowProducts} resetFormArrival={resetFormArrival} setFilterData={setFilterData} filterDatas={filterDatas} productlist={productlist} setProductList={setProductList} setSelectedShowProducts={setSelectedShowProducts} />
      )}

      {/* Edit Arrival Form */}
      {methodType === 'edit' && (
        <AddEditArrival setMethodType={setMethodType} resetForm={resetForm} touched={touched} errors={errors} formData={formData} handleInputChange={handleInputChange} handleBlur={handleBlur} suppliers={suppliers} shippingMethods={shippingMethods} handleDateChange={handleDateChange} searchTerm={searchTerm} setIsDropdownOpen={setIsDropdownOpen} isDropdownOpen={isDropdownOpen} filteredProducts={filteredProducts} selectedProducts={selectedProducts} setSearchTerm={setSearchTerm} handleProductClick={handleProductClick} setShowAddProductModal={setShowAddProductModal} setProductSearchQuery={setProductSearchQuery} setAvailableProducts={setAvailableProducts} setSelectedProducts={setSelectedProducts} fetchAvailableProducts={fetchAvailableProducts} toggleAllProductsCheckbox={toggleAllProductsCheckbox} products={products} toggleProductCheckbox={toggleProductCheckbox} handleProductChange={handleProductChange} removeProduct={removeProducts} handleAddArrival={handleUpdateArrival} isLoading={isLoading} type={'edit'} arrivalToEdit={arrivalToEdit} selectedShowProducts={selectedShowProducts} resetFormArrival={resetFormArrival} setFilterData={setFilterData} filterDatas={filterDatas} productlist={productlist} setProductList={setProductList} setSelectedShowProducts={setSelectedShowProducts} />

      )}

      {methodType === 'clone' && (
        <AddEditArrival setMethodType={setMethodType} resetForm={resetForm} touched={touched} errors={errors} formData={formData} handleInputChange={handleInputChange} handleBlur={handleBlur} suppliers={suppliers} shippingMethods={shippingMethods} handleDateChange={handleDateChange} searchTerm={searchTerm} setIsDropdownOpen={setIsDropdownOpen} isDropdownOpen={isDropdownOpen} filteredProducts={filteredProducts} selectedProducts={selectedProducts} setSearchTerm={setSearchTerm} handleProductClick={handleProductClick} setShowAddProductModal={setShowAddProductModal} setProductSearchQuery={setProductSearchQuery} setAvailableProducts={setAvailableProducts} setSelectedProducts={setSelectedProducts} fetchAvailableProducts={fetchAvailableProducts} toggleAllProductsCheckbox={toggleAllProductsCheckbox} products={products} toggleProductCheckbox={toggleProductCheckbox} handleProductChange={handleProductChange} removeProduct={removeProducts} handleAddArrival={handleAddArrival} isLoading={isLoading} type={'clone'} arrivalToEdit={arrivalToEdit} selectedShowProducts={selectedShowProducts} resetFormArrival={resetFormArrival} setFilterData={setFilterData} filterDatas={filterDatas} productlist={productlist} setProductList={setProductList} setSelectedShowProducts={setSelectedShowProducts} />

      )}

      {/* View Arrival Details */}
      {methodType === 'view' && (
        <div className="row">
          <div className="col-sm-12">
            <div className='start-main'>
              <div className="setting-right position-relative arrival-page">
                <div className="table-actions justify-content-end ">
                  {checkEditPermission(data?.permissions, 'arrival') && (
                    <>
                      <div className='arival-view-cs'>
                        <button class="reset "
                          onClick={() => {
                            setMethodType('');
                            resetForm();
                            setSelectedProducts([])
                          }}>Back</button>
                        <button
                          className="btn add edit-btn-main me-3"
                          onClick={async () => {
                            setFormData({
                              supplier: arrivalToEdit.supplier_id || '',
                              shipping_method: arrivalToEdit.shipping_method_name || '',
                              order_remark: arrivalToEdit.order_remark || '',
                              container_no: arrivalToEdit.container_no || '',
                              atd: arrivalToEdit.atd || '',
                              ata: arrivalToEdit.ata || '',
                              eta: arrivalToEdit.eta || '',
                              status: arrivalToEdit.status === true ? 1 : 0 || 0,
                              arrival_id: arrivalToEdit?.arrival_id || ''
                            });
                            await getSingleArrivalProduct(arrivalToEdit)
                            setMethodType('edit')
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </>

                  )}
                </div>
                <div className='arival-view-edit'>
                  <div className="setting-inner">
                    <div className="overview-card p-3">
                      <h3 className='ps-0 pt-0 border-0'>Overview</h3>
                      <div className="row">
                        <div className="col-md-6">
                          <ul>
                            <li><p>Supplier Code</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.supplier_code}</h4></li>
                            <li><p>Shipping Method</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.shipping_method_name}</h4></li>
                            <li><p>Order Remark</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.order_remark}</h4></li>
                            <li><p>Container No/Air/Local/Truck</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.container_no}</h4></li>
                            <li><p className='mb-0'>Supplier Name</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4 className='mb-0'>{arrivalToEdit?.supplier_name_en}</h4></li>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul>
                            <li><p>ATD</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.atd}</h4></li>
                            <li><p>ATA</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.ata}</h4></li>
                            <li><p>ETA</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.eta}</h4></li>
                            <li><p>Status</p><span><img src={window.getPublicUrl('/assets/images/overview-icon.svg')} alt="" /></span><h4>{arrivalToEdit?.status == '0' ? 'Incompleted' : 'Completed'}</h4></li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <h3 className='border-0 py-3 p-0'>Products</h3>
                      <div className='permission-table-inner view mt-0' >
                        <table className="custom-table table-striped product-bottom-cs">
                          <thead>
                            <tr>
                              <th className="product-code">Product Code</th>
                              <th className="product-name">Product Name</th>
                              <th className="specification">Specification</th>
                              <th className="quantity">Quantity</th>
                              <th className="barcode">Barcode</th>
                            </tr>
                          </thead>

                          <tbody>
                            {productShow.map((product, index) => (
                              <tr key={index}>
                                <td className="product-code">{product.code}</td>
                                <td className="product-name">{product.name_en}</td>
                                <td className="specification">{product.specification}</td>
                                <td className="quantity">{product.quantity}</td>
                                <td className="barcode">{product.barcode || '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td className="product-code" style={{ borderTop: '2px solid #dee2e6' }}></td>
                              <td className="product-name" style={{ borderTop: '2px solid #dee2e6' }}></td>
                              <td className="specification" style={{ textAlign: 'right', fontWeight: 600, borderTop: '2px solid #dee2e6' }}>Total Quantity</td>
                              <td className="quantity" style={{ fontWeight: 600, borderTop: '2px solid #dee2e6' }}>
                                {productShow?.reduce((total, item) => total + (Number(item.quantity) || 0), 0)}
                              </td>
                              <td className="barcode" style={{ borderTop: '2px solid #dee2e6' }}></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Arrival;

